/**
 * Utility for consistent logging across the application
 * Handles both regular logs in development and error logging/monitoring in all environments
 */

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * Log information in development environment
 * @param {...any} args - Arguments to log
 */
export const log = (...args) => {
    if (isDevelopment) {
        // eslint-disable-next-line no-console
        console.log('[CustomerPortal]', ...args);
    }
};

/**
 * Log an error with context
 * @param {Error|string} error - The error object or message
 * @param {string} context - The context where the error occurred
 * @param {Object} [metadata] - Additional metadata about the error
 */
export const logError = (error, context, metadata = {}) => {
    const errorMessage = error instanceof Error ? error.message : error;
    const errorObject = {
        message: errorMessage,
        context,
        timestamp: new Date().toISOString(),
        ...metadata
    };

    if (isDevelopment) {
        // eslint-disable-next-line no-console
        console.error('[CustomerPortal Error]', errorObject);
        if (error instanceof Error && error.stack) {
            // eslint-disable-next-line no-console
            console.error(error.stack);
        }
    } else {
        // In production, we would send this to an error monitoring service
        // TODO: Implement production error logging service
        // Example: Sentry.captureException(error, { extra: errorObject });
    }

    return errorMessage;
};
